import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Status } from '../_models/status';

import { environment } from '../../environments/environment';

@Injectable()
export class StatusService {
  constructor(private http: Http) { }

  getAll(): Promise<Status[]> {
      return this.http.get(environment.apiUrl + 'status')
              .toPromise()
              .then((response: Response) => response.json())
              .catch(x => console.log(x));
  }
}




// WEBPACK FOOTER //
// ./src/app/_services/status.service.ts